import { useNotifications } from '@sequencehq/core-components'
import { useMutation } from '@sequencehq/api/utils'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { logError } from '@sequencehq/utils'

export const useDeleteNumeralMapping = () => {
  const { displayNotification } = useNotifications()

  const { mutateAsync: deleteTaxCategoryNumeralMapping } = useMutation(
    dashboardv99990101Client.deleteTaxCategoryNumeralMapping
  )

  return async (taxCategoryId: string) => {
    try {
      await deleteTaxCategoryNumeralMapping(taxCategoryId)

      displayNotification('Numeral mapping removed', {
        type: 'success'
      })
    } catch (error) {
      console.error('Failed to remove numeral mapping:', error)
      logError(error)

      // Try to extract a more specific error message
      const errorMessage =
        error instanceof Error && error.message
          ? `Failed to remove tax category mapping: ${error.message}`
          : 'Failed to remove tax category mapping'

      displayNotification(errorMessage, {
        type: 'error'
      })
      throw error
    }
  }
}
